module.exports = __webpack_public_path__ + "img/흐리고비.dde10a75.png";